export default "__VITE_ASSET__h2NlY9lu__"